export const useMods = (
  size,
  reversed,
  highlight,
  isOutOfStock,
  isWholeStock,
  isNotInStock,
  infoIndent,
  withHover,
  contentVisibilityAuto,
) => {
  const mods = computed(() => ({
    size: unref(size),
    dir: unref(reversed) ? 'reversed' : 'normal',
    highlight: unref(highlight),
    out_of_stock: unref(isOutOfStock),
    whole_stock: unref(isWholeStock),
    not_in_stock: unref(isNotInStock),
    touch_support: !unref(withHover),
    info_indent: unref(infoIndent),
    content_visibility_auto: unref(contentVisibilityAuto),
  }))

  return {
    mods,
  }
}
